<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-ckxmxssr',2)">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="分类汇总" name="first">
          <customerTable v-if="activeName === 'first'" ref="table" :array="table_col" :data="tableData.records" :change-tabs="changeTabs" :is-show-config="isShowConfig" :table-type="activeName === 'first'?'classification':'project'" :public-word="activeName==='first'?'分类':'项目'" :loading="loading" :default-sort="defaultSort" :show-only-data="true" @statisticsChange="statisticsChange" @timeChange="timeChange" @searchChange="searchChange" @onCheckDetail="onCheckDetail" @onPrint="onPrint" @tableSortChange="tableSortChange" @onlyDataCheckbox="onlyDataCheckbox" />
        </el-tab-pane>
        <el-tab-pane label="项目汇总" name="second">
          <customerTable v-if="activeName === 'second'" ref="table" :array="table_col" :data="tableData.records" :change-tabs="changeTabs" :is-show-config="isShowConfig" :table-type="activeName === 'first'?'classification':'project'" :public-word="activeName==='first'?'分类':'项目'" :loading="loading" :default-sort="defaultSort" :show-only-data="true" @statisticsChange="statisticsChange" @timeChange="timeChange" @searchChange="searchChange" @onCheckDetail="onCheckDetail" @onPrint="onPrint" @tableSortChange="tableSortChange" @onlyDataCheckbox="onlyDataCheckbox" />
        </el-tab-pane>
      </el-tabs>

      <el-pagination background layout="prev, pager, next" :total="tableData.total" :current-page="currentPage" @current-change="pageDataFn"></el-pagination>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import api from '../../api/index.js';
import customerTable from '../others/customer_table';

export default {
  components: {
    customerTable
  },
  data() {
    return {
      activeName: 'first',
      timeRange: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      searchInput: '',
      tableData: [],
      pagedata: [],
      table_col: [],
      update: true, // 刷新视图专用
      changeTabs: false, // 是否改变tabs
      isShowConfig: false, // 是否展示操作列
      currentPage: 1,
      loading: true,
      // 储存排序条件
      defaultSort: {},
      sortProp: '',
      sortOrder: '',
      isRead: 0, // 0是有数据 1是没数据
      statisticsRange: '1'
    };
  },
  watch: {
    activeName(val) {
      this.timeRange = [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ];
      this.changeTabs = !this.changeTabs;
      this.currentPage = 1;
      this.isRead = 0;
      if (val === 'second') {
        this.onGetItemPool(this.sortProp, this.sortOrder);
      } else {
        this.onGetItemIncome(this.sortProp, this.sortOrder);
      }
    }
  },
  activated() {
    this.currentPage = 1;
    if (this.activeName === 'second') {
      this.onGetItemPool(this.sortProp, this.sortOrder);
    } else {
      this.onGetItemIncome(this.sortProp, this.sortOrder);
    }
  },
  methods: {
    // 获取 项目收入- 分类汇总页面
    onGetItemIncome(item, SortType) {
      this.loading = true;
      let sortObj;
      if (!item && !SortType) {
        sortObj = {
          itemSort: undefined,
          numSort: undefined,
          moneySort: undefined
        };
      } else {
        sortObj = {
          itemSort: item === 'itemNumber' ? SortType === 'descending' ? 1 : 0 : undefined,
          numSort: item === 'orderNum' ? SortType === 'descending' ? 1 : 0 : undefined,
          moneySort: item === 'countIncome' ? SortType === 'descending' ? 1 : 0 : undefined
        };
      }
      const vm = this;
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.currentPage,
        pageSize: 10,
        isRead: this.isRead,
        itemSort: sortObj.itemSort,
        numSort: sortObj.numSort,
        moneySort: sortObj.moneySort,
        timeCountType: this.statisticsRange
      };
      api.getItemIncome(data).then((res) => {
        vm.tableData = res.data;
        vm.loading = false;
        vm.table_col = [
          {
            name: '分类名称',
            prop: 'dictTypeName',
            showTip: false,
            tip: ''
          },
          {
            name: '项目个数',
            prop: 'itemNumber',
            showTip: true,
            tip: '分类下包含的服务项目个数',
            sortable: 'custom'
          },
          {
            name: '出售次数（次）',
            prop: 'orderNum',
            showTip: false,
            tip: '',
            sortable: 'custom'
          },
          {
            name: '实收合计（元）',
            prop: 'countIncome',
            showTip: false,
            tip: '',
            sortable: 'custom'
          }
        ];
        vm.isShowConfig = false;
        // 手动排序
        vm.defaultSort = { prop: item, order: SortType };
        // //console.log(vm.defaultSort)
      });
    },
    // 获取 项目收入- 项目汇总页面
    onGetItemPool(item, SortType) {
      const vm = this;
      vm.loading = true;
      let sortObj;
      if (!item && !SortType) {
        sortObj = {
          itemSort: undefined,
          moneySort: undefined
        };
      } else {
        sortObj = {
          itemSort: item === 'countNum' ? SortType === 'descending' ? 1 : 0 : undefined,
          moneySort: item === 'countMoney' ? SortType === 'descending' ? 1 : 0 : undefined
        };
      }
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.currentPage,
        pageSize: 10,
        isRead: this.isRead,
        itemSort: sortObj.itemSort,
        moneySort: sortObj.moneySort,
        timeCountType: this.statisticsRange
      };
      api.getItemPool(data).then((res) => {
        vm.tableData = res.data;
        vm.loading = false;

        vm.table_col = [
          {
            name: '项目名称',
            prop: 'itemName',
            showTip: false,
            tip: ''
          },
          {
            name: '项目分类',
            prop: 'typeName',
            showTip: false,
            tip: '分类下包含的服务项目个数'
          },
          {
            name: '出售数量',
            prop: 'countNum',
            showTip: false,
            tip: '',
            sortable: 'false'
          },
          {
            name: '实收合计（元）',
            prop: 'countMoney',
            showTip: false,
            tip: '',
            sortable: 'false'
          }
        ];
        vm.isShowConfig = true;
        vm.defaultSort = { prop: item, order: SortType };
      });
    },
    // 统计方式改变回调
    statisticsChange(val) {
      this.statisticsRange = val;
      if (this.activeName === 'second') {
        this.onGetItemPool(this.sortProp, this.sortOrder);
      } else {
        this.onGetItemIncome(this.sortProp, this.sortOrder);
      }
    },
    // 时间改变回调
    timeChange(val) {
      this.timeRange = val;
      if (this.activeName === 'second') {
        this.onGetItemPool(this.sortProp, this.sortOrder);
      } else {
        this.onGetItemIncome(this.sortProp, this.sortOrder);
      }
    },
    // 搜索框改变回调
    searchChange(val) {
      this.searchInput = val;
      this.currentPage = 1;
      if (this.activeName === 'second') {
        this.onGetItemPool(this.sortProp, this.sortOrder);
      } else {
        this.onGetItemIncome(this.sortProp, this.sortOrder);
      }
    },
    // 分页数据处理函数
    pageDataFn(number) {
      // //处于第几页 number
      // //保存每页数据的函数
      // let pagedata = [];
      // //pagesize=10 每页条数
      // //设置开始
      // let start = 10 * number - 10;
      // // 设置结束长度
      // let end = 10 * number; //长度判断 //所有分页数据 this.tableData
      // end = end > this.tableData.length ? this.tableData.length : end;
      // for (let i = start; i < end; i++) {
      //     //所有分页数据 this.tableData
      //     pagedata.push(this.tableData[i]);
      // }
      // this.pagedata = pagedata;
      // //console.log(number);
      this.currentPage = number;
      if (this.activeName === 'second') {
        this.onGetItemPool(this.sortProp, this.sortOrder);
      } else {
        this.onGetItemIncome(this.sortProp, this.sortOrder);
      }
    },
    // 查看详情
    onCheckDetail(row, time) {
      if (this.Lib.checkPower('beauty-5-ckxmxssrxq') == false) return;
      this.$router.push({
        name: 'finance-detail',
        params: {
          itemId: row.itemId,
          publicWord: 'item',
          name: row.itemName,
          date: time,
          timeCountType: this.statisticsRange
        }
      });
    },
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dyxmxssr') == false) return;
      const vm = this;
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: 1,
        pageSize: 9999999,
        isRead: this.isRead,
        timeCountType: this.statisticsRange
      };
      if (this.activeName === 'second') {
        api.getItemPool(data).then((res) => {
          vm.$print({
            data: res.data.records,
            title: '项目汇总',
            table_tol: vm.table_col
          });
        });
      } else {
        api.getItemIncome(data).then((res) => {
          // console.log(res.data)
          vm.$print({
            data: res.data.records,
            title: '项目汇总',
            table_tol: vm.table_col
          });
        });
      }
    },
    // 排序调用方法
    tableSortChange(prop, order) {
      // debugger
      if (this.sortProp === prop && this.sortOrder === order) {
        // this.$refs['table'].$refs['table'].clearSort()
        return;
      }
      this.sortProp = prop;
      this.sortOrder = order;

      if (this.activeName === 'second') {
        this.onGetItemPool(prop, order);
      } else {
        this.onGetItemIncome(prop, order);
      }
    },
    onlyDataCheckbox(val) {
      this.isRead = val ? 0 : 1;
      if (this.activeName === 'second') {
        this.onGetItemPool(this.sortProp, this.sortOrder);
      } else {
        this.onGetItemIncome(this.sortProp, this.sortOrder);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title {
    display: flex;
}
</style>
